<template>
  <div>
    <div class="content">
      <div class="banner">
        <img :src="productData.goodsPic" alt />
      </div>
      <div class="product">
        <div class="title">{{productData.goodsName}}</div>
        <div class="mode-wrap" v-if="productData.goodsMenu">
          <div class="mode" v-for="val in productData.goodsMenu.split(',')" :key="val">
            <i></i>
            {{val}}
          </div>
        </div>
        <div class="btn-wrap">
          <el-button round @click.native="reserve()">立即订阅</el-button>
        </div>
      </div>
    </div>
    <div class="describe">{{productData.goodsDesc}}</div>
  </div>
</template>

<script>
export default {
  props: ["productData"],
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {
    reserve() {
      this.$emit("showDialog", 2);
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  background: #fff;
  display: flex;
  padding: 16px;
  .banner {
    width: 770px;
    img {
      width: 100%;
    }
  }
  .product {
    margin-left: 36px;
    flex: 1;
    .title {
      font-size: 20px;
      color: #242424;
      margin: 20px 0 34px 0;
    }
    .mode-wrap {
      display: flex;
      flex-wrap: wrap;
      .mode {
        width: 50%;
        font-size: 16px;
        margin-bottom: 26px;
        i {
          display: inline-block;
          height: 9px;
          width: 9px;
          background: #606060;
          border: 1px solid #929292;
          margin-right: 10px;
        }
      }
    }
    .btn-wrap {
      .el-button {
        width: 100%;
        background: #ff7651;
        color: #fff;
      }
    }
  }
}
.describe {
  font-size: 14px;
  padding: 16px;
}
</style>